import React from 'react';
import classNames from 'classnames';
import t from '@rcm/i18n-client';
import noop from 'lodash/noop';
import {
    Button,
    createField,
    FieldFactoryProps,
    JsxSelectOption,
    RawFieldRenderer,
    SelectValue,
} from 'forms';
import '../../styles/button-list-select-field.scss';
import { CrudHub } from 'forms-crud';
import OptionControlsPortal from '../OptionControlsPortal';

interface FFProps<Value extends SelectValue>
    extends FieldFactoryProps<Value, HTMLDivElement>, ExtraProps<Value> { }

interface ExtraProps<Value extends SelectValue> {
    /**
     * List of possible values
     */
    options?: Array<JsxSelectOption<Value>>;
}

const ButtonListSelectField = createField(<Value extends SelectValue>({
    className,
    disabled,
    name = null,
    onValueChange = noop,
    options = [],
    value = null,
    Renderer, error, label, // Props we don't want to pass along
    ...props
}: FFProps<Value>) => <div
        className={`button-list-select-field ${className}`}
        {...props}>
    {options && options.map(({value: val, label: subLabel}) =>
        <OptionControlsPortal.Channel key={val}>
            <div className={classNames(
                        'option',
                        'row',
                        {selected: val === value}
                    )}>
                <div className="col-xs-12 col-sm-3">
                    <Button btn="primary"
                        onClick={(e) => onValueChange(val, value, name, e)}
                        text={t(val === value ? 'Selected' : 'Select')}
                        icon={val === value ? 'check' : 'unchecked'}
                        disabled={disabled || val === value}
                    />
                    <OptionControlsPortal.Receive />
                </div>
                {subLabel}
            </div>
        </OptionControlsPortal.Channel>
    )}
</div>, RawFieldRenderer);

export default ButtonListSelectField;
